module.exports = __webpack_public_path__ + "img/logoGun2.63e2ba4d.png";